export const IconArrowUp = `<svg width="9" height="5" viewBox="0 0 9 5" xmlns="http://www.w3.org/2000/svg" transform="rotate(180deg)">
<path d="M4.37744 4.5L8.27456 0.75H0.480327L4.37744 4.5Z" />
  </svg>`;
